import * as yup from 'yup';

import { endpointUrlValidation } from './endpointUrl';

export const bulkEditWebhookFormSchema = yup
  .object({
    endpointUrl: endpointUrlValidation(),
    businessUnitUuid: yup.string().label('Business unit'),
    xAuthUuid: yup.string().label('X-Auth-UUID')
  })
  .required();

export type BulkEditWebhookFormValues = yup.InferType<
  typeof bulkEditWebhookFormSchema
>;
